<template lang="pug">
  .change-password
    .container-fluid.change-password-header
      .container
        .row.py-3
          .col-5
            h3.title-path
              router-link(to="/") {{ $t('profile.profile') }}
              span#arrow-delimiter >
              span {{ $t('profile.change_password') }}
            h1 {{ $t('profile.change_password') }}
          .col.text-right.pt-2
            router-link#cancel-link(
              :to="{ name: 'ProfilePage' }"
              class="btn btn-outline-primary mr-3 px-4 py-0"
            )
              | {{ $t('profile.cancel') }}
            input.btn.btn-primary.px-4.py-0#change-password-button(
              :value="$t('profile.change')"
              type='button'
              @click="changePassword"
            )
    .container-fluid.change-password-inputs
      .container
        .old-password
          p {{ $t('profile.old_password') }}
          input(
            :class="{ 'red-bordered': !isEmpty(oldPasswordError) }"
            v-model="oldPassword"
            type="password"
          )
        .errors
          p {{ oldPasswordError }}
        .new-password
          p {{ $t('profile.new_password') }}
          input(
            :class="{ 'red-bordered': !isEmpty(newPasswordError) }"
            v-model="newPassword"
            type="password"
          )
        .password-confirmation
          p {{ $t('profile.password_confirmation') }}
          input(
            :class="{ 'red-bordered': !isEmpty(newPasswordError) }"
            v-model="passwordConfirm"
            type="password"
          )
        .errors
          p {{ newPasswordError }}
</template>

<script>
  import { api } from '@/api.js'
  import { isEmpty } from 'lodash'

  export default {
    data() {
      return {
        oldPassword: '',
        newPassword: '',
        passwordConfirm: '',
        newPasswordError: '',
        oldPasswordError: ''
      }
    },

    computed: {
      changePasswordUrl() {
        return `/profiles/change_password`
      },

      requestParams() {
        return {
          old_password: this.oldPassword,
          new_password: this.newPassword,
          password_confirmation: this.passwordConfirm
        }
      },

      passwordUnconformed() {
        return this.newPassword != this.passwordConfirm
      },

      passwordInvalidSize() {
        return this.newPassword.length < 8 && this.passwordConfirm.length < 8
      },

      passwordIsEmpty() {
        return isEmpty(this.newPassword) && isEmpty(this.passwordConfirm)
      }
    },

    methods: {
      isEmpty,

      changePassword() {
        this.newPasswordError = null
        this.validatePasswords()
        if (this.newPasswordError == null) {
          this.sendRequest()
        }
      },

      sendRequest() {
        api.post(this.changePasswordUrl, this.requestParams).then((resp) => {
          if (resp.data.success) {
            this.$bvToast.show('saved-notification')
            this.$router.push({ name: 'ProfilePage' })
          }
        }).catch((err) => {
          if (err.response.status == 404) {
            this.oldPasswordError = this.$t('profile.incorrect_old_password')
          }
        })
      },

      resetErrorMessages() {
        this.newPasswordError = ''
        this.oldPasswordError = ''
      },

      validatePasswords() {
        if (this.passwordInvalidSize) {
          this.newPasswordError = this.$t('profile.must_be_more_8')
        }
        if (this.passwordUnconformed) {
          this.newPasswordError = this.$t('profile.passwords_not_matches')
        }
        if (this.passwordIsEmpty) {
         this.newPasswordError = this.$t('profile.passwords_not_filled')
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .change-password-header {
    background-color: #fff;
    box-shadow: 0 2px 16px 0 rgba(176, 186, 197, 0.2);
    margin-bottom: 10px;

    h3 {
      color: #7c91a7;
      font-size: 11px;
      font-weight: 700;

      a {
        color: #7c91a7;
        text-decoration: none;
      }
    }

    #arrow-delimiter {
      margin: 0 5px;
    }

    h1 {
      color: #3d4a57;
      font-size: 30px;
      font-weight: 700;
    }

    #cancel-link,
    #change-password-button {
      background: transparent;
      border: 1px solid rgba(0, 156, 234, 0.3);
      border-radius: 4px;
      color: #009cea;
      font-size: 14px;
      height: 40px;
      line-height: 38px;
    }

    #change-password-button {
      background-image: linear-gradient(90deg, rgba(24, 172, 235, 0.98) 0%, #18a4eb 100%);
      border-radius: 4px;
      color: #fff;
      font-size: 14px;
      height: 40px;
      line-height: 38px;
    }
  }

  .change-password-inputs {
    margin-top: 2%;

    .old-password,
    .new-password,
    .password-confirmation {
      margin-bottom: 1rem;
    }

    p {
      color: #7c91a7;
      font-size: 13px;
      font-weight: 700;
      margin-bottom: 5px;
      margin-top: 0;
    }

    .errors {
      margin: 1px 0 10px 0;

      p {
        color: red;
        font-weight: 300;
      }
    }

    input {
      border: 1px solid #dfe6ee;
      border-radius: 4px;
      color: #313541;
      font-size: 14px;
      font-weight: 500;
      height: 40px;
      padding: 10px 12px;
    }
  }
</style>
